// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3_w_w","icon":"styles_icon__3Q21B"};